import type { MealtimeGroup } from '@/lib/chefs/types'

interface MealtimeGroupHeaderProps {
  group: MealtimeGroup
  /** False on the chef Orders screen, which shows no meal counts (PROD-1502). */
  showCount?: boolean
}

/**
 * Order-group section heading under a mealtime (PROD-1296): the band the
 * kitchen packs separately ("Preschool · 8 Meals", "K-8 · 30 Meals"). Sits
 * between the MealtimeHeader and that group's DeliverableRows, on screen and
 * on the printed campus sheet. The count is the group's OWN true meal count
 * (`MealtimeGroup.meals`), never derived from its rows.
 */
export function MealtimeGroupHeader({ group, showCount = true }: MealtimeGroupHeaderProps) {
  return (
    <div
      data-testid="mealtime-group-header"
      className="flex flex-wrap items-baseline gap-2 border-b border-border bg-muted/40 px-4 py-1.5 text-xs">
      <span className="font-semibold uppercase tracking-wide text-foreground">{group.label}</span>
      {showCount ? (
        <>
          <span className="text-muted-foreground">·</span>
          <span className="text-muted-foreground">
            {group.meals} {group.meals === 1 ? 'Meal' : 'Meals'}
          </span>
        </>
      ) : null}
    </div>
  )
}
